import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Select from 'react-select';
import DatePicker from 'react-datepicker';
import TimePicker from 'rc-time-picker';
import moment from 'moment';
import { employerJobCreationStepsSingle } from '../../../../constants/jobs';
import { getNowInTimeZone } from '../../../../helpers/timezones';
import { monthDayYearWithSlashFormat, timeFormatUi } from '../../../../constants/date';
import AddLocationModal from '../createJob/LocationScheduleStep/AddLocationModal';
import blackoutDates from '../../../../constants/blackoutDates'
import { UIShowAlert } from '../../../../actions/ui';

class LocationDateStep extends Component {
  static propTypes = {
    selectedLocation: PropTypes.object,
    companyLocations: PropTypes.array.isRequired,
    locationsList: PropTypes.array.isRequired,
    handleSelectLocation: PropTypes.func.isRequired,
    addLocationToJob: PropTypes.func.isRequired,
    startDate: PropTypes.object,
    handleChangeStartDate: PropTypes.func.isRequired,
    startTime: PropTypes.object,
    endTime: PropTypes.object,
    validationErrors: PropTypes.object.isRequired,
    handleChangeStartTime: PropTypes.func.isRequired,
    handleChangeEndTime: PropTypes.func.isRequired,
    isFirstStepFilled: PropTypes.func.isRequired,
    goToStep: PropTypes.func.isRequired
  };

  state = {
    locationModalIsOpen: false
  };

  openAnotherLocationModal = () => {
    this.setState({ locationModalIsOpen: true });
  };

  closeAddLocationModal = () => {
    this.setState({ locationModalIsOpen: false });
  };

  addLocationToJob = locationData => {
    return this.props.addLocationToJob(locationData).then(() => {
      this.closeAddLocationModal();
    });
  };

  checkForBlackout = (moment) => {
    const { UIShowAlert, handleChangeStartDate } = this.props
    const message = <p>Please contact <a href="mailto:support@gravywork.com">support@gravywork.com</a> to post a job for this date.</p>
    
    if (blackoutDates.includes(moment._d.getTime())) {
      return UIShowAlert(message)
    }

    handleChangeStartDate(moment)
  }

  render () {
    const { companyLocations, locationsList, selectedLocation, handleSelectLocation, startDate,
      startTime, handleChangeStartTime, endTime, handleChangeEndTime, isFirstStepFilled, goToStep, validationErrors } = this.props;
    const { locationModalIsOpen } = this.state;
    const options = companyLocations.map(location => ({
      label: `${location.location_name}, ${location.address}`,
      value: location.id,
      data: location
    }));
    const jobMinDate = getNowInTimeZone();
    return (
      <React.Fragment>
        <section className='job-posting-section'>
          <header><h4>Job Location</h4></header>
          <h5><label className='sub-header' htmlFor='location-select'>Location:</label></h5>
          <Select
            id='location-select'
            onChange={handleSelectLocation}
            options={options}
            placeholder='Choose'
            value={selectedLocation}
          />
          <p className='mt-2'>
            Choose from list or <span className='create-location-link' onClick={this.openAnotherLocationModal}>Add Another Location</span>
          </p>
          <AddLocationModal
            isOpen={locationModalIsOpen}
            closeModal={this.closeAddLocationModal}
            locationsList={locationsList}
            addLocationToJob={this.addLocationToJob}
          />
        </section>
        <section className='job-posting-section'>
          <header><h4>Shift</h4></header>
          <div className='shift-form-wrapper'>
            <div>
              <h5><label className='sub-header' htmlFor='date-datepicker'>Start Date:</label></h5>
              <DatePicker
                id='date-datepicker'
                className='datepicker-input create-job-input'
                placeholderText='Select Date'
                selected={startDate}
                onChange={moment => this.checkForBlackout(moment)}
                dateFormat={monthDayYearWithSlashFormat}
                minDate={jobMinDate}
                dropdownMode='select'
              />
            </div>
            <div>
              <h5><label className='sub-header'>Start Time:</label></h5>
              <TimePicker
                showSecond={false}
                className='create-job-timepicker-wrapper'
                placeholder='Select Time'
                onChange={handleChangeStartTime}
                format={timeFormatUi}
                use12Hours
                minuteStep={15}
                value={startTime}
                defaultOpenValue={moment().startOf('day')}
              />
            </div>
            <div>
              <h5><label className='sub-header'>End Time:</label></h5>
              <TimePicker
                showSecond={false}
                className='create-job-timepicker-wrapper'
                placeholder='Select Time'
                onChange={handleChangeEndTime}
                format={timeFormatUi}
                use12Hours
                minuteStep={15}
                value={endTime}
                defaultOpenValue={moment().startOf('day')}
              />
            </div>
            {validationErrors.hours && (
              <p className='error-message right'>{validationErrors.hours}</p>
            )}
          </div>
        </section>
        { isFirstStepFilled() && (
          <div className='nav-buttons-wrapper'>
            <button
              className='gravy-button info-btn next-step-button'
              onClick={() => goToStep(employerJobCreationStepsSingle.second.id)}
            >Next</button>
          </div>
        )}
      </React.Fragment>
    );
  }
}

export default connect(null, { UIShowAlert })(LocationDateStep);



// WEBPACK FOOTER //
// ./src/components/app/createJob/createJobEmployerSingle/LocationDateStep.js